<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M10 5.5C10.8284 5.5 11.5 4.82843 11.5 4C11.5 3.17157 10.8284 2.5 10 2.5C9.17157 2.5 8.5 3.17157 8.5 4C8.5 4.82843 9.17157 5.5 10 5.5Z"
            fill="currentColor"
        />
        <path
            d="M5.5 10C5.5 10.8284 4.82843 11.5 4 11.5C3.17157 11.5 2.5 10.8284 2.5 10C2.5 9.17157 3.17157 8.5 4 8.5C4.82843 8.5 5.5 9.17157 5.5 10Z"
            fill="currentColor"
        />
        <path
            d="M10 11.5C10.8284 11.5 11.5 10.8284 11.5 10C11.5 9.17157 10.8284 8.5 10 8.5C9.17157 8.5 8.5 9.17157 8.5 10C8.5 10.8284 9.17157 11.5 10 11.5Z"
            fill="currentColor"
        />
        <path
            d="M16 11.5C16.8284 11.5 17.5 10.8284 17.5 10C17.5 9.17157 16.8284 8.5 16 8.5C15.1716 8.5 14.5 9.17157 14.5 10C14.5 10.8284 15.1716 11.5 16 11.5Z"
            fill="currentColor"
        />
        <path
            d="M17.5 4C17.5 4.82843 16.8284 5.5 16 5.5C15.1716 5.5 14.5 4.82843 14.5 4C14.5 3.17157 15.1716 2.5 16 2.5C16.8284 2.5 17.5 3.17157 17.5 4Z"
            fill="currentColor"
        />
        <path
            d="M4 5.5C4.82843 5.5 5.5 4.82843 5.5 4C5.5 3.17157 4.82843 2.5 4 2.5C3.17157 2.5 2.5 3.17157 2.5 4C2.5 4.82843 3.17157 5.5 4 5.5Z"
            fill="currentColor"
        />
        <path
            d="M11.5 16C11.5 16.8284 10.8284 17.5 10 17.5C9.17157 17.5 8.5 16.8284 8.5 16C8.5 15.1716 9.17157 14.5 10 14.5C10.8284 14.5 11.5 15.1716 11.5 16Z"
            fill="currentColor"
        />
        <path
            d="M16 17.5C16.8284 17.5 17.5 16.8284 17.5 16C17.5 15.1716 16.8284 14.5 16 14.5C15.1716 14.5 14.5 15.1716 14.5 16C14.5 16.8284 15.1716 17.5 16 17.5Z"
            fill="currentColor"
        />
        <path
            d="M5.5 16C5.5 16.8284 4.82843 17.5 4 17.5C3.17157 17.5 2.5 16.8284 2.5 16C2.5 15.1716 3.17157 14.5 4 14.5C4.82843 14.5 5.5 15.1716 5.5 16Z"
            fill="currentColor"
        />
    </svg>
</template>
